import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Navigate } from 'react-router-dom';

const ProtectedRegisterRoute = ({ children }) => {
    const [isAuthorized, setIsAuthorized] = useState(null); // null = loading, true = authorized, false = not authorized

    useEffect(() => {
        const token = Cookies.get("token");
        
        if (!token) {
            setIsAuthorized(false);
            return;
        }

        try {
            const decoded = jwtDecode(token);
            
            console.log(decoded,"decoded")
            // Check if token is expired
            const currentTime = Date.now() / 1000;
            if (decoded.exp < currentTime) {
                setIsAuthorized(false);
                return;
            }
            
            // Check if user is admin
            if (decoded.role === "companyadmin" || decoded.role === "superadmin") {
                setIsAuthorized(true);
            } else {
                setIsAuthorized(false);
            }
        } catch (error) {
            console.error('Invalid token:', error);
            setIsAuthorized(false);
        }
    }, []); // Remove 'url' from dependency array

    // Loading state
    if (isAuthorized === null) {
        return <div>Loading...</div>; // Or your loading component
    }

    // Not authorized - redirect
    if (isAuthorized === false) {
        return <Navigate to="/register" replace />;
    }

    // Authorized - render children
    return children;
};

export default ProtectedRegisterRoute;